// extracted by mini-css-extract-plugin
module.exports = {"item":"c6e8ba5398--item--1lHZr"};